import React from 'react';
import ReactDOM from 'react-dom/client';
import App from './App';
import { ToastProvider } from './components';
import { SchoolProvider } from './schoolContext';

const root = ReactDOM.createRoot(document.getElementById('root'));
root.render(<React.StrictMode><SchoolProvider><ToastProvider><App /></ToastProvider></SchoolProvider></React.StrictMode>);
